import React from 'react';
const IconCommentFilledFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 18H10V22H12.11L15.47 18H22V2H2V18ZM7 7H17V9H7V7ZM7 11H15V13H7V11Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconCommentFilledFill;